export const cf7MailSent = () => {
  document.addEventListener('wpcf7mailsent', function (event) {
    const form = event.target;
    const formContent = form.querySelector('.ty-form-message');

    if (formContent) {
      form.style.position = 'relative';
      formContent.style.opacity = '0';
      formContent.style.visibility = 'hidden';

      const p = document.createElement('p');
      p.classList.add('ty-success-message');
      p.textContent = 'Thank you, the form has been submitted.';
      formContent.parentNode.insertBefore(p, formContent.nextSibling);
    }
  }, false);
};
